import styled from "styled-components";

export const HeaderContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 16px 8px;

    .backBtn {
        position: absolute;
        left: 12px;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        background: #fff;
        color: #495057;
        text-decoration: none;
        transition: background 0.15s;
        &:hover { background: #e9ecef; }
    }

    .headerTitle {
        font-family: "BebasNeue";
        font-size: 32px;
        letter-spacing: 1px;
        color: #333;
    }

    .helpBtn {
        position: absolute;
        right: 12px;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        background: #fff;
        color: #495057;
        font-size: 18px;
        font-weight: 600;
        font-family: 'Roboto', sans-serif;
        cursor: pointer;
        transition: background 0.15s;
        &:hover { background: #e9ecef; }
    }
`;
